<template>
    <div class="entry-content">
        <v-client-table
			v-if="!preloaderVisibility"
			v-model="lessonTemplates"
			:columns="columnsOptions"
			:options="options"
		>
            <router-link
				slot="name"
                slot-scope="lessons"
                :to="`/templates/${$route.params.courseTemplateId}/lessons/${lessons.row.lessonTemplateId}/units?page=1`"
			>
                {{ lessons.row.name }}
			</router-link>
			<router-link
				slot="edit"
                slot-scope="lessons"
				class="nav-item"
                :to="`/lesson/edit/${lessons.row.lessonTemplateId}`"
			>
				Edit
			</router-link>
		</v-client-table>
        <div
        v-if="preloaderVisibility"
        class="table-skeleton" />
		<PreloaderComponent v-if="preloaderVisibility"/>
		<Paginate
			v-if="pageCount !== 1 && lessonTemplates.length"
			v-model="currentPage"
			:page-count="pageCount"
			:container-class="'pagination'"
			:page-class="'page-item'"
			:prev-text="'<'"
			:next-text="'>'"
			:prev-class="'page-item'"
			:next-class="'page-item'"
			:click-handler="paginationHandler"/>
	</div>
</template>


<script>

import Paginate from 'vuejs-paginate'

import CheckAPI from '@/api'
import PreloaderComponent from '@/components/common/PreloaderComponent'

export const tableOptions = {
	resizableColumns: false,
	perPage: 30,
	perPageValues: [],
	filterable: false,
	highlightMatches: false,
	filterByColumn: false,
	sortable: [],
	skin: '',
	hiddenColumns: ['id'],
	headings: {
		delete: false,
		edit: false
	}
};

export default {
	name: "LessonTemplatePage",
    components: {
        PreloaderComponent,
        Paginate
    },
    data() {
		return {
            columnsOptions: ['name', 'edit'],
            lessonsTemplates: [],
			lessonTemplates: [],
            options: tableOptions,
            pageCount: 0,
            total: 0,
            currentPage: 1,
            size: 30,
            preloaderVisibility: true
        }
    },
    mounted() {
		this.setInitialPage();
    },
    methods: {
        async fetchLessonTemplates() {
            const response = await CheckAPI.getLessonTemplates(
				this.currentPage - 1,
				this.size,
				this.$route.params.courseTemplateId
			);
            this.total = response.data.data.total_items
			this.pageCount = response.data.data.total_pages
            this.lessonTemplates = response.data.data.items
            this.preloaderVisibility = false
        },
        setPage() {
			this.currentPage = parseInt(this.$route.query.page || 1);
			this.$router.push({path: this.$route.path, query: { page: parseInt(this.$route.query.page || 1) }})
			this.fetchLessonTemplates();
		},
		setInitialPage() {
			if (this.$route.query.page !== 1) {
				this.currentPage = parseInt(this.$route.query.page || 1);
				this.$router.push({path: this.$route.path, query: { page: parseInt(this.$route.query.page || 1) }})
				this.fetchLessonTemplates();
			}
		},
		paginationHandler(e) {
			this.currentPage = e;
			this.$router.push({path: this.$route.path, query: { page: e }})
			this.preloaderVisibility = true
			this.fetchLessonTemplates();
		}
    },
    watch: {
		'$route.query.page': {
			deep: true,
			handler() {
				this.preloaderVisibility = true;
				this.setPage();
			}
		}
	}
}
</script>

<style scoped lang="scss">

.table-heading {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.pagination {
	list-style: none;
	display: flex;
	justify-content: center;
	padding: 0;

	.page-item {
		transition: .4s ease all;
		background-color: #34558b;

		a {
			display: inline-block;
			padding: 6px 10px;
			color: white;
			border-radius: 6px;
		}

		&.active {
			background-color: #35495e;
		}

		&.disabled {
			a {
				color: #35495e;
				cursor: not-allowed;
			}

			&:hover {
				background-color: #fff;
			}

			background-color: #fff;
		}

		margin: 3px;
		border-radius: 6px;

		&:hover {
			a {
				color: white;
			}

			background-color: #35495e;
		}
	}
}

.table-skeleton {
  height: 492px;
}


</style>